import { useDataRequest, useDataRequestForm } from '@vivli/features/data-requests/infrastructure/hook';
import { DataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { useEffect } from 'react';
import { DataRequestFormComponent } from '@vivli/features/data-requests/components';
import { useParams } from 'react-router';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { DataRequestContextWrapper, StatusUpdateContextWrapper } from '@vivli/features/data-requests/infrastructure/wrappers';
import { NotificationContextWrapper } from '@vivli/shared/features/notification/infrastructure/wrappers';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { FormProvider } from 'react-hook-form';

export const DataRequestDraftFeature = () => {
    const { requestId } = useParams();
    const { dataRequest } = useDataRequest(requestId);
    const { hasPermission } = useActiveUserContext();
    const formApi = useDataRequestForm(dataRequest, hasPermission(PermissionsEnum.DrActAdv));

    useEffect(() => {
        if (!dataRequest) return;

        formApi.reset(dataRequest);
    }, [dataRequest]);

    if (!dataRequest?.id) {
        return <LoadIndicatorCenteredView />;
    }

    return (
        <FormProvider {...formApi}>
            <DataRequestContextWrapper dataRequest={dataRequest}>
                <DataRequestContext.Consumer>
                    {({ organizations }) => {
                        if (!organizations) {
                            return <LoadIndicatorCenteredView />;
                        }
                        return (
                            <StatusUpdateContextWrapper>
                                <NotificationContextWrapper>
                                    <DataRequestFormComponent />
                                </NotificationContextWrapper>
                            </StatusUpdateContextWrapper>
                        );
                    }}
                </DataRequestContext.Consumer>
            </DataRequestContextWrapper>
        </FormProvider>
    );
};
